/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from 'react';
import { connect } from 'react-redux';
import { LastLocationProvider } from 'react-router-last-location';
import { Routes } from './app/router/Routes';
import { I18nProvider, LayoutSplashScreen } from './_psb';
import { ToastProvider } from 'react-toast-notifications';
import Notification from './components/Notifications';
import Modal from './components/Modal';
import { setUserProfiles } from './modules/auth/Actions';
import Cookie from 'js-cookie';

class App extends React.Component {
  // { setProfiles} = this.props
  componentWillMount() {
    console.log(this.props.lang);
    // if (this.props.lang === 'ar') {
    //   require('./styles/css/rtl.css');
    // } else {
    

    // require('./index.scss');
    // }
  }
  checkToken = () => {
    const token = Cookie.get('TOKEN');
    if (token) {
      const profiles = localStorage.getItem('profiles');
      console.log(JSON.parse(profiles));
      this.props.setProfiles(JSON.parse(profiles));
    }
  };

  render() {
    this.checkToken();
    return (
      <>
        <ToastProvider>
          <Notification />
          <Modal />
          {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
          <React.Suspense fallback={<LayoutSplashScreen />}>
            {/* Override `basename` (e.g: `homepage` in `package.json`) */}
            {/*             <ConnectedRouter history={history}>
             */}
            {/*             <BrowserRouter basename={basename}>
             */}{' '}
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            <LastLocationProvider>
              {/* Provide psb theme overrides. */}
              {/* <ThemeProvider> */}
              {/* Provide `react-intl` context synchronized with Redux state.  */}
              <I18nProvider>
                {/* Render routes with provided `Layout`. */}
                <Routes />
              </I18nProvider>
              {/* </ThemeProvider> */}
            </LastLocationProvider>
            {/* </BrowserRouter> */}
            {/*             </ConnectedRouter>
             */}{' '}
          </React.Suspense>
        </ToastProvider>
      </>
    );
  }
}

const mapStateToProps = store => ({
  lang: store.i18n.lang
});

const mapDispatchToProps = {
  setProfiles: setUserProfiles
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
